import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as classNames from "classnames";
import * as _ from "lodash";
import * as React from "react";
import {Line, Pie, Bar} from "react-chartjs-2";
import {injectIntl, InjectedIntlProps} from "react-intl";
import * as Common from "./common";
import TableDefinition, {TabId} from "./table-definition";
import HotTable from "../common/hot-table";
import Popup from "../../ppi/ppi-detail/utils/popup";
import PriorityFilter from "../../priority-filter";
import {Pane, Tabs} from "../../tabs";
import * as Model from "../../../model";
import ExcelDownload from "../excelfile";
// import Spinner from 'react-spinkit';
import Spinner from "./spinner";

const currenyOptions: Intl.NumberFormatOptions = {
    currency: "EUR",
    style: "currency",
};

class ScenarioDetailComponent extends React.Component<any> {
    setHotTableRef: (element: any) => void;
    private chartOptionsPie: Chart.ChartOptions;
    private chartOptions: Chart.ChartOptions;
    private firstColWidth: number;
    private defaultBarChartOptions: Chart.ChartOptions = {
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                        callback: (v) => this.props.intl.formatNumber(v, currenyOptions),
                    },
                },
                {
                    gridLines: {display: false},
                    id: "inhabitants",
                    position: "right",
                    ticks: {callback: (v) => this.props.intl.formatNumber(v)},
                },
            ],
        },
        tooltips: {
            callbacks: {
                label: (tooltip, data) => {
                    const datasetIndex = tooltip.datasetIndex;
                    const dataIndex = tooltip.index;
                    const value = data.datasets[datasetIndex].data[dataIndex] as number;

                    if (data.datasets.length === datasetIndex - 1) {
                        const total = _.sum(data.datasets[datasetIndex].data);
                        const percentage = total ? _.round((value * 100) / total) : 0;
                        const formattedValue = this.props.intl.formatNumber(
                            value,
                            currenyOptions
                        );
                        return `${data.datasets[datasetIndex].label} : ${formattedValue} (${percentage}%)`;
                    } else {
                        const formattedValue = this.props.intl.formatNumber(value);
                        return `${data.datasets[datasetIndex].label} : ${formattedValue}`;
                    }
                },
            },
        },
    };
    private hotTable: HotTable = null;

    constructor(props) {
        super(props);

        this.hotTable = null; // hot table instance via ref
        this.setHotTableRef = (element) => {
            this.hotTable = element;
        };

        this.chartOptionsPie = {
            tooltips: {
                callbacks: {
                    label: (tooltip, data) => {
                        const datasetIndex = tooltip.datasetIndex;
                        const dataIndex = tooltip.index;
                        const datasetData = data.datasets[datasetIndex].data as number[];
                        const value = datasetData[dataIndex];
                        const total = datasetData.reduce((prev, value) => prev + value);
                        const percentage = total ? Math.round((value * 100) / total) : 0;
                        const formattedValue = this.props.intl.formatNumber(
                            value,
                            currenyOptions
                        );

                        return `${data.labels[dataIndex]} : ${formattedValue} (${percentage}%)`;
                    },
                },
            },
        };

        this.chartOptions = {
            maintainAspectRatio: false,
            scales: {
                xAxes: [{offset: true}],
                yAxes: [
                    {
                        ticks: {
                            callback: (v) => this.props.intl.formatNumber(v, currenyOptions),
                        },
                    },
                ],
            },
            tooltips: {
                callbacks: {
                    label: (tooltip, data) => {
                        const datasetIndex = tooltip.datasetIndex;
                        const dataIndex = tooltip.index;
                        const value = data.datasets[datasetIndex].data[dataIndex] as number;
                        const formattedValue = this.props.intl.formatNumber(
                            value,
                            currenyOptions
                        );
                        return `${data.labels[dataIndex]} : ${formattedValue}`;
                    },
                },
            },
        };

        this.firstColWidth = 450;
    }

    renderHotTableComponent() {
        return (
            <HotTable
                consulted={this.props.consulted}
                currentTab={this.props.currentTab}
                root="main"
                title="Articles"
                headers={this.props.headers}
                data={this.props.data}
                firstColWidth={this.firstColWidth}
                fixedColumnLeft={1}
                scenario={this.props.scenario}
                tableDefinition={this.props.tableDefinition}
                hideRows={this.props.hideRows}
                onChange={this.props.onChange}
                onToggleChapter={this.handleToggleChapter.bind(this)}
                onChapterValueUpdated={this.props.onChapterValueUpdated}
                onAccountValueUpdated={this.props.onAccountValueUpdated}
                ref={this.setHotTableRef}
                settings={{minRows: 100}}
            />
        );
    }

    render() {
        return (
            <div className="scenario-detail">
                <div className="scenario-detail-header">
                    <a
                        className="back-to-list"
                        href="javascript:void()"
                        onClick={this.props.onBack}
                    >
                        <FontAwesomeIcon icon="backward"/>
                    </a>
                    {this.renderTitle()}&nbsp;
                    <PriorityFilter
                        selectedPriorities={this.props.selectedPriorities}
                        setSelectedPriorities={this.props.setSelectedPriorities}
                        onPrioritiesChange={this.props.onPrioritiesChange}
                        pageTitle={this.props.pageTitle}
                    />&nbsp;
                    <label className="scenario-title">
                        <input
                            type="checkbox"
                            checked={this.props.hideRows}
                            onClick={this.props.onHideRows}/>
                        &nbsp; Cacher les lignes vides
                    </label>
                    {this.props.currentTab == "synthesis" && (
                        <a
                            href="javascript:void(0);"
                            style={{width: "190px", marginLeft: "35px"}}
                            onClick={this.props.onShowGraphic}
                        >
                            <p className="button button-default">Afficher les graphiques</p>
                        </a>
                    )}
                    <div style={{marginLeft: "30px"}}>
                        <ExcelDownload
                            props={this.props}
                            Excel={() => this.props.Excel()}
                            show={"detail"}
                            current={this.props.currentTab}
                        />
                    </div>
                </div>

                <div className="specialTabs tabs-container">
                    <div className="tabs">
                        <div
                            className={classNames("tab", {
                                active: this.props.currentTab == "revenues",
                            })}
                            onClick={() => this.handleChangeTab("revenues")}
                        >
                            Recettes
                        </div>

                        <div
                            className={classNames("tab", {
                                active: this.props.currentTab == "spending",
                            })}
                            onClick={() => this.handleChangeTab("spending")}
                        >
                            Dépenses
                        </div>

                        <div
                            className={classNames("tab", {
                                active: this.props.currentTab == "synthesis",
                            })}
                            onClick={() => this.handleChangeTab("synthesis")}
                        >
                            Synthèse
                        </div>
                    </div>

                    <div className="panes">
                        <div className="pane active">
                            {!!this.props.loading && <Spinner/>}
                            {/* {
								this.props.loading ? (
									<div className="ppi-loader">
										<Spinner fadeIn="none" name="wave" color="#3d3c3f" />
									</div>
								) : this.renderHotTableComponent()
							} */}
                            {this.renderHotTableComponent()}
                            {/* {
								this.props.loading ? (
									<div className="ppi-loader">
										<Spinner fadeIn="none" name="wave" color="#3d3c3f" />
									</div>
								) : this.renderHotTableComponent()
							} */}
                        </div>
                        {this.props.chartData &&
                        this.props.chartDataSpending &&
                        this.props.chartDataRevenues ? (
                            <Popup
                                onHide={this.props.onCloseGraph}
                                title="Graphiques scénario"
                                className="scenario-graph-popup"
                            >
                                <Tabs selected={0}>
                                    <Pane id="synthese" title="Synthèse">
                                        <br/>
                                        {this.props.chartData && (
                                            <Line
                                                data={this.props.chartData}
                                                options={this.chartOptions}
                                            />
                                        )}
                                    </Pane>
                                    <Pane id="recette" title="Recettes">
                                        <br/>
                                        {this.props.chartDataRevenues && (
                                            <Pie
                                                data={this.props.chartDataRevenues}
                                                options={this.chartOptionsPie}
                                            />
                                        )}
                                        <br/>
                                        {this.props.chartDataRevenuesBar && (
                                            <Bar
                                                data={this.props.chartDataRevenuesBar}
                                                options={this.defaultBarChartOptions}
                                            />
                                        )}
                                    </Pane>
                                    <Pane id="depense" title="Dépenses">
                                        <br/>
                                        {this.props.chartDataSpending && (
                                            <Pie
                                                data={this.props.chartDataSpending}
                                                options={this.chartOptionsPie}
                                            />
                                        )}
                                        <br/>
                                        {this.props.chartDataSpendingBar && (
                                            <Bar
                                                data={this.props.chartDataSpendingBar}
                                                options={this.defaultBarChartOptions}
                                            />
                                        )}
                                    </Pane>
                                </Tabs>
                                <p style={{textAlign: "center"}}>
                                    Vous pouvez cacher un élément sur le graphique en cliquant sur
                                    sa légende.
                                </p>
                            </Popup>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }

    private handleChangeTab(type: TabId) {
        this.props.onTabChange(type);
    }

    private handleToggleChapter(chapter: Model.Chapter) {
        this.props.onToggleChapter(chapter);
        this.hotTable.getInstance().render();
    }

    private renderTitle(): React.ReactNode {
        const number = this.props.scenario.identifier;
        const description = this.props.scenario.description;
        let label = `${number} - ${description} / Définition du scénario pour l'année `;

        return (
            <span className="scenario-title">
        {label} <strong>{this.props.scenario.year}</strong>
      </span>
        );
    }
}

export default injectIntl(ScenarioDetailComponent);

export interface Props {
    pageTitle: string;
    chartData: Chart.ChartData;
    chartDataRevenues: Chart.ChartData;
    chartDataRevenuesBar: Chart.ChartData;
    chartDataSpending: Chart.ChartData;
    chartDataSpendingBar: Chart.ChartData;
    consulted: boolean;
    currentTab: string;
    data: Data;
    headers: number[];
    selectedPriorities: number[];
    scenario: Model.Scenario;
    revenues: Data;
    spending: Data;
    synthesis: Data;
    tableDefinition: ReturnType<typeof TableDefinition>;
    loading: boolean;
    hideRows: boolean;

    Excel(): void;

    onAccountValueUpdated?(): void;

    onBack(): void;

    onChange(type: "account", data: Common.BaseChangeData): void;

    onChange(type: "account_year", data): void;

    onChange(type: "chapter", data: Common.BaseChangeData): void;

    onChange(type: "main", data: Common.Changes): void;

    onChange(type: "account_comment", data: Common.AccountYearChangeData): void;

    onChapterValueUpdated?(): void;

    onCloseGraph(): void;

    onPrioritiesChange(priorities: number[]): void;

    onShowGraphic(): void;

    onTabChange(tab: TabId): void;

    onHideRows(): void;

    onToggleChapter(chapter: Model.Chapter): void;

    setSelectedPriorities(prioorities: number[]): void;
}

export type Data = DataRow[];

type DataRow = any[];
type InjectedProps = Props & InjectedIntlProps;



// WEBPACK FOOTER //
// ./src/component/scenarii/detail/detail-component.tsx